<div *ngIf="relationshipId">
    <label> <a href="{{managePartnerUri}}"> Manage Partnership </a>> {{selectedPartner}}<span class="pi pi-fw pi-pencil action" (click)="editPartner(partner)" *ngIf="!loading"></span></label>
</div>
<p-progressSpinner *ngIf="!partnership || refresh"></p-progressSpinner>
<div class="formgroup">
    <app-partner-details [relationshipId] = "relationshipId" [readOnly]="true" (onSelectPartner)="selectPartner($event)" (onChange)="partnerDetailsChange($event)" [refresh]="refresh" *ngIf="relationshipId"></app-partner-details>
</div>

<div class="formgroup">
    <app-manage-partner-user [relationship] = "partnership"></app-manage-partner-user>
</div>

<div *ngIf="displayDialog && partnership">
    <app-edit-partnership [displayDialog] = "displayDialog"  [relationshipId] = "relationshipId" (onDialogClose)="onDialogClose($event)" [partner] = "partnerUser" [partnership] = "partnership" (onRelationships) = "refreshRelationships($event)"></app-edit-partnership>
</div>